import React from "react";
import "./Background.css";
import { IProps } from "./IProps";

const Background: React.FC<IProps> = ({ children }) => {
  return <div className="background">{children}</div>;
};

export default Background;
